import { DialogComponent } from "./chunk-TVDGYGWY.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Modal/Modal.Content.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Content = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx(DialogComponent.Content, __spreadProps(__spreadValues({
    className: clsx("pd:modal__content", className)
  }, rest), {
    children
  }));
};
var Modal_Content_default = Content;
export { Modal_Content_default };